/*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router'
import AccountOrderHistory from './AccountOrderHistory/AccountOrderHistory'
import AccountOrderDetail from './AccountOrderDetail/AccountOrderDetail'
import { AccountOrdersProvider } from 'msp-integrations'

const AccountOrders = () => {
  const { path } = useRouteMatch()

  return (
    <AccountOrdersProvider>
      <Switch>
        <Route exact path={path}>
          <AccountOrderHistory />
        </Route>
        <Route exact path={`${path}/:orderNo`}>
          <AccountOrderDetail />
        </Route>
      </Switch>
    </AccountOrdersProvider>
  )
}

AccountOrders.getTemplateName = () => 'account-order-history'

export default AccountOrders
